import React, { useState, useEffect } from "react";
import "./uploadLp.css";
import { BsPaperclip } from "react-icons/bs";
import { Scroll } from "../../components/Scroll function/scroll";
import LpForm from "../packageDetailsPage/LpForm";
import { Link } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Modal } from "react-responsive-modal";
import Popup from "../../components/PopupNotification/LpPopup";

function UploadLp() {
  const [open1, setOpen1] = useState(false);
  const onOpenModal1 = () => setOpen1(true);
  const onCloseModal1 = () => setOpen1(false);

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  useEffect(() => {
    setTimeout(() => {
      onOpenModal1();
    }, 60000);
  }, []);

  return (
    <div className="uploadlp">
      <div className="uploadBackground">
        <div className="logoDiv">
          <img
            src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/6666d24d-f9ef-44e3-8aa7-5230252a55c7.webp"
            alt="logoImg"
            width="100%"
          />
        </div>
        <div className="container d_flex align_start">
          <div className="leftsideDiv  ">
            {/* <div className="logoDiv">
              <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/6666d24d-f9ef-44e3-8aa7-5230252a55c7.webp"
                alt="https://staticcdn.redcliffelabs.com/media/gallary-file/None/6666d24d-f9ef-44e3-8aa7-5230252a55c7.webp"
                
              />
            </div> */}
            <div className="leftSideContent">
              <span className="topFirstHeading">
                India's Leading Diagnostics Lab
              </span>
              <span className="topSecondHeading">
                Book Any Test with Home Sample Collection
              </span>
            </div>
          </div>
          <div className="rightSideDiv  ">
            <div className="uploadLp">
              <LpForm
                // focus={inputFocusDiv}
                isLp={true}
                butname={"SUBMIT"}
                buttonId={"LpTop"}
                formId={"lpTop"}
                lpNumber={`8988988585`}
                position={"Top"}
                push={true}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="mobileview">
        <div>
          <div className="logoDiv">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/6666d24d-f9ef-44e3-8aa7-5230252a55c7.webp"
              alt="logoImg"
              width="100%"
            />
          </div>
          <img
            width="100%"
            src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/cde0458a-9d10-4d3f-84b0-b76c96c164cd.webp"
          />
          <div className="leftSideContent">
            <span className="topFirstHeading">
              India's Leading Diagnostics Lab
            </span>
            <span className="topSecondHeading">
              Book Any Test with Home Sample Collection
            </span>
          </div>
        </div>

        <div className="rightSideDiv  ">
          <div className="uploadLp">
            <LpForm
              push={true}
              upload={true}
              formId={`lpMobile`}
              lpNumber={`8988988585`}
            />
          </div>
        </div>
      </div>
      <div className="container   cardDiv">
        <div className="row margin_2 padding12">
          <div className="row_card">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/861f0ae4-8f2f-44ee-becf-21d96d1c40cb.svg"
              alt="img"
              style={{ width: "6rem" }}
            />
            <span className="card_content">Easy To Book Tests</span>
          </div>

          <div className="row_card">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/43d646ce-4348-4ce3-a67c-fd9519df81d1.svg"
              alt="img"
              style={{ width: "6rem" }}
            />
            <span className="card_content sampleText">
              Sample Collection On Time
            </span>
          </div>

          <div className="row_card">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/24de08d2-052f-429f-9fa6-1500ae3665fd.svg"
              alt="img"
              style={{ width: "6rem" }}
            />
            <span className="card_content">Accurate Reports</span>
          </div>
        </div>
      </div>
      <div className="bg_light padding12">
        <div className="container middleDiv ">
          <div>
            <h2 className="title">Our Top Health Packages</h2>
            <p className="font-2">
              Book packages and tests from our top-selling list
            </p>
          </div>
          <div></div>
          <div className="packageLists">
            <div className="list">
              <span>- Smart Full Body Checkup</span>
              <span>- Advance Full Body Checkup</span>
              <span>- Healthy Heart Package</span>
              <span>- Vitamin D and Vitamin B12 Screening</span>
              <span>- Kidney Function Test</span>
              <span>- CRP Test</span>
            </div>

            <div className="list">
              <span>- LIPID Profile Test</span>
              <span>- hba1c Test</span>
              <span>- Double Marker Test</span>
              <span>- Platelet test</span>
              <span>- Allergy Test</span>
              <span>- HIV Test</span>
            </div>

            <div className="list">
              <span>- Dengue Test</span>
              <span>- Malaria Test</span>
              <span>- Testosterone Test</span>
              <span>- Creatinine Blood Test</span>
              <span>- HCG Test</span>
              <span>- Liver Function Test</span>
            </div>
          </div>

          <div className="mmobileCar">
            <Carousel
              swipeable={true}
              draggable={true}
              infinite={true}
              showDots={true}
              responsive={responsive}
              ssr={true} // means to render carousel on server-side.
              autoPlay={true}
              autoPlaySpeed={2500}
              transitionDuration={200}
              deviceType={"tablet"}
            >
              <div className="list">
                <span>- Smart Full Body Checkup</span>
                <span>- Advance Full Body Checkup</span>
                <span>- Healthy Heart Package</span>
                <span>- Vitamin D and Vitamin B12 Screening</span>
                <span>- Kidney Function Test</span>
                <span>- CRP Test</span>
              </div>

              <div className="list">
                <span>- LIPID Profile Test</span>
                <span>- hba1c Test</span>
                <span>- Double Marker Test</span>
                <span>- Platelet test</span>
                <span>- Allergy Test</span>
                <span>- HIV Test</span>
              </div>

              <div className="list">
                <span>- Dengue Test</span>
                <span>- Malaria Test</span>
                <span>- Testosterone Test</span>
                <span>- Creatinine Blood Test</span>
                <span>- HCG Test</span>
                <span>- Liver Function Test</span>
              </div>
            </Carousel>
          </div>
        </div>
        <div className="buttonDiv">
          <span className="booknow" onClick={() => Scroll()}>
            Book Test Now
          </span>
        </div>
      </div>

      <div className="uploadFooter padding12">
        <div className="container footerContent">
          <div className="footerLeft ">
            <h2 className="footerHeading">Still Looking?</h2>
            <p className="footerText">
              If you couldn't find what you were looking for, try uploading
              prescription
            </p>
          </div>
          <div className="footerRight">
            <p className="uploadButon" onClick={() => Scroll()}>
              <span className="iconUPload">
                <BsPaperclip />{" "}
              </span>{" "}
              Upload a Prescription
            </p>

            {/* <Link className="lp4link btnFooter" to="/terms-of-use">Terms of Use</Link> */}
          </div>
        </div>
      </div>
      <div className="termsCondition">
        <h2>Terms and conditions</h2>

        <ul>
          <li>
            You consent Redcliffe Labs to get in touch with you by submitting
            the form at your suitable schedule.
          </li>
          <li>
            Our medical team and consultant will be there to offer guidance to
            make you understand the entire testing procedure cycle. They will
            ensure simplifying the complete process to avert any probability of
            disease.
          </li>
          <li>
            Our health experts will also check your organs and history for the
            purpose of pre-diagnosing and for recommending the essential tests.
            If you have a prescription with you, then you can also share that
            with our medical team.
          </li>
          <li>
            After the confirmation of your scheduled appointment, our expert
            phlebotomist will come and visit your address at the given time to
            collect the blood sample. He/she will also ensure taking other
            samples if required according to your prescription.
          </li>
          <li>
            After the sample is collected then it will be transferred to the
            certified lab to maintain the integrity and quality of the test.
          </li>
          <li>
            After the results are out, our health experts or medical team will
            cross-check the details and will only send you after the evaluation.
            The reports will be sent to you on your mobile or email address.
            Further, you can get in touch with the doctors for counseling and
            they evaluate if everything is fine.
          </li>
          <li>
            We also provide 24*7 customer support that all your queries and
            problems are solved.
          </li>
        </ul>
        <p>
          Dear customer, we are very happy to know your registration with
          Redcliffe Labs. You consent to the notifications such as health
          checkup reminders, marketing discounts, etc. we may send you over the
          phone by entering your number on the website. You also allow for
          receiving calls from us.
        </p>
      </div>

      {/* Notification popup */}
      <Modal
        classNames={{
          overlay: "customOverlay",
          modal: "notificationPopup_modal",
        }}
        open={open1}
        onClose={onCloseModal1}
        center
      >
        <Popup setOpen={setOpen1} />
      </Modal>
    </div>
  );
}

export default {
  component: UploadLp,
};
